import React from 'react';

import MuiAutocompleteField from '@mui/material/Autocomplete';

import { FormControl, InputLabel } from '@src/components/form';

import TextField from './TextField';

const AutocompleteField = React.forwardRef((props, ref) => {
  const { value, options, onChange, error, helperText, label, sx, ...restProps} = props;
  const selected = options.find((o) => o.value === value) ?? null;
  const fieldOnChange = (_, option) => {
    const selectedValue = option ? option.value : null;
    onChange(selectedValue);
  };

  return (
    <FormControl fullWidth sx={sx} error={error}>
      <InputLabel error={error}>{label}</InputLabel>

      <MuiAutocompleteField
        ref={ref}
        value={selected}
        options={options}
        onChange={fieldOnChange}
        renderInput={
          (params) => (
            <TextField
              {...params}
              variant="outlined"
              helperText={helperText}
              error={error}
            />
          )
        }
        {...restProps}
      />
    </FormControl>
  );
});
AutocompleteField.displayName = 'AutocompleteField';
export default AutocompleteField;
